import React, { Component } from 'react';
import firebase from 'firebase';
import Mantenimiento from './mantenimiento';

// Si Firestore no responde en este tiempo se carga la aplicación normalmente.
const TIEMPO_ESPERA_MS = 5000;

/**
 * Escucha en tiempo real la bandera /configuraciones/mantenimiento.showMantenimiento.
 * - true: solo se pinta <Mantenimiento /> (con imagen_web si está definida o con texto si está vacía)
 *   y la aplicación (children) no se monta, por lo que no es posible realizar ninguna otra acción en la página.
 * - false, documento inexistente o error de lectura: se pinta la aplicación.
 */
class MantenimientoGate extends Component {

    state = {
        cargando: true,
        showMantenimiento: false,
        imagenWeb: ''
    }

    componentDidMount() {
        this.timeout = setTimeout(() => {
            if (this.state.cargando) {
                this.setState({ cargando: false });
            }
        }, TIEMPO_ESPERA_MS);

        this.unsubscribe = firebase.firestore().doc('/configuraciones/mantenimiento').onSnapshot(
            (snap) => {
                const data = snap.exists ? snap.data() : {};
                const showMantenimiento = data.showMantenimiento === true;
                const imagenWeb = (typeof data.imagen_web === 'string') ? data.imagen_web.trim() : '';
                this.setState({
                    cargando: false,
                    showMantenimiento,
                    imagenWeb
                });
            },
            (error) => {
                console.error('MantenimientoGate: no se pudo leer la bandera de mantenimiento', error);
                this.setState({ cargando: false, showMantenimiento: false, imagenWeb: '' });
            }
        );
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        if (this.state.cargando) {
            return null;
        }

        if (this.state.showMantenimiento) {
            return <Mantenimiento imagen_web={this.state.imagenWeb} />;
        }

        return this.props.children;
    }
}

export default MantenimientoGate;
